import React, { useState, useEffect } from 'react'
import moment from 'moment'
import { observer } from 'mobx-react'

import DataTable from '../../../DataTable'
import Panel from '../../../../UniformComponents/Panel'
import Search from '../../../Search'

import './style.scss'
import Anchor from '../../../../UniformComponents/Anchor'

const LoggedInUsers = observer(({ store, intranetStore }) => {
    const [filteredList, setFilteredList] = useState([])
    const [searchModule, setSearchModule] = useState({})

    const columns = [
        {
            name: 'id',
            key: 'userId',
            dataTransform: (userId) => (
                <Anchor
                    isExternal
                    target="_blank"
                    href={`/intranet/dataViewer?schema=explori_v3&tablename=user&filter=userId|eq|${userId}`}
                >
                    {userId}
                </Anchor>
            ),
        },
        {
            name: 'sessionId',
            key: 'sessionId',
        },
        {
            name: 'First Name',
            key: 'firstName',
        },
        {
            name: 'Last Name',
            key: 'lastName',
        },
        {
            name: 'Email',
            key: 'email',
        },
        {
            name: 'Role',
            key: 'role',
        },
        {
            name: 'Client',
            key: 'clientId',
            dataTransform: (clientId, { clientName }) => (
                <Anchor
                    isExternal
                    target="_blank"
                    href={`/intranet/dataViewer?schema=explori_v3&tablename=client&filter=clientId|eq|${clientId}`}
                >
                    {clientName}
                </Anchor>
            ),
        },
        {
            name: 'Session Start',
            key: 'sessionStart',
            dataTransform: (date) => (
                moment(date).format('DD/MM/YYYY HH:mm:ss')
            ),
        },
        {
            name: 'Last Requet',
            key: 'lastRequest',
            dataTransform: (date) => (
                moment(date).format('DD/MM/YYYY HH:mm:ss')
            ),
        },
        {
            name: 'Seconds since last request',
            key: 'secondsSinceLastRequest',
        },
    ]

    const filter = () => {
        const { loggedInUsers } = intranetStore

        const { searchStr } = searchModule
        const re = new RegExp(searchStr, 'i')

        setFilteredList(
            (loggedInUsers ?? []).filter((user) => (
                columns.some(({ key }) => String(user[key]).match(re))
            )),
        )
    }

    useEffect(() => {
        store.breadcrumps = [
            {
                name: 'intranet',
                url: '/intranet',
                title: 'Intranet',
            },
            {
                name: 'loggedInUsers',
                url: '/intranet/loggedInUsers',
                title: 'Logged-in Users',
            },
        ]
    }, [])

    useEffect(() => {
        filter()
    }, [intranetStore.loggedInUsers])

    return (
        <Panel
            cssClass="loggedInUsers"
        >
            <Search
                ref={(s) => { setSearchModule(s) }}
                onSearch={filter}
            />
            <DataTable
                store={{ filteredList }}
                dataSet={filteredList}
                columns={columns}
                numRows={filteredList.length}
                rowId="sessionId"
                inMemory
            />
        </Panel>
    )
})

export default LoggedInUsers
